import React from "react";
import { useDispatch } from "react-redux";
import useLanguageChange from "../../../hooks/useLanguageChange";
import {
    setIsScreenShareInfoOpen,
    setIsScreenShareMirrorWarningIgnored,
    setIsScreenShareMirrorWarningOpen,
} from "../../../reducers/twilioEvents-reducer";
import { handleOnScreenShare } from "./ScreenShareUtils";

const ScreenShareMirrorWarning = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    const handleClosePopUp = () => {
        dispatch(setIsScreenShareMirrorWarningOpen(false));
        dispatch(setIsScreenShareInfoOpen(true));
        dispatch(setIsScreenShareMirrorWarningIgnored(true));
    };

    return (
        <div className='share-screen-information' data-testid='screenShare-mirror'>
            <div className='share-screen-information-in'>
                <div className='share-screen-information-row'>
                    <div className='share-screen-info-text'>
                        <p>{localisedValues["screen_share_info"]}</p>
                    </div>
                    <div className='share-screen-info-btn button-inline d-flex align-items-center more-space'>
                        <div className='button'>
                            <button className='btn default-btn-primary btn-with-icon text-nowrap' onClick={handleOnScreenShare}>
                                <span className='btn-text'>{localisedValues["stop_share_screen"]}</span>
                            </button>
                        </div>
                        <div className='button'>
                            <button className='btn default-btn-link font-weight-600' onClick={handleClosePopUp}>
                                {localisedValues["ignore"]}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ScreenShareMirrorWarning;
